export const categorizeItems = (items) => {
    const standardItems = [];
    const subscriptionItems = [];
    items.forEach((item) => {
        if (item.subscription === 1) {
            subscriptionItems.push(item);
        }
        else {
            standardItems.push(item);
        }
    });
    return { standardItems, subscriptionItems };
};
//# sourceMappingURL=categorizeItems.js.map